// src/App.js
import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ErrorBoundary from "./components/UI/ErrorBoundary";
import { routes } from "./config/routesConfig";
import { ThemeProvider } from "./context/ThemeContext";
import { useDispatch } from "react-redux";
import { initializeI18nThunk } from "./store/thunks/i18nThunks";

const App = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const savedTheme = localStorage.getItem("theme") || "theme-royal-sapphire";
    document.documentElement.className = savedTheme;

    // Initialize i18n
    dispatch(initializeI18nThunk());
  }, [dispatch]);

  return (
    <ErrorBoundary>
      <ToastContainer />
      <ThemeProvider>
        <Router>
          <Routes>
            {routes.map((route, index) => {
              const { element, children, ...rest } = route;
              return (
                <Route key={index} element={element} {...rest}>
                  {children &&
                    children.map((child, childIndex) => {
                      const {
                        element: childElement,
                        children: subChildren,
                        ...childRest
                      } = child;
                      return (
                        <Route
                          key={childIndex}
                          element={childElement}
                          {...childRest}
                        >
                          {subChildren &&
                            subChildren.map((subChild, subChildIndex) => (
                              <Route
                                key={subChildIndex}
                                element={subChild.element}
                                {...subChild}
                              />
                            ))}
                        </Route>
                      );
                    })}
                </Route>
              );
            })}
          </Routes>
        </Router>
      </ThemeProvider>
    </ErrorBoundary>
  );
};

export default App;
